export const SITE_NAME = 'CSSBuy Spreadsheet';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

const FALLBACK_SITE_URL = 'https://cssbuybr.team';

export function getSiteUrl(): string {
  const url = import.meta.env.VITE_SITE_URL || FALLBACK_SITE_URL;
  return url.replace(/\/+$/, '');
}

function readMeta(selector: string): string {
  if (typeof document === 'undefined') return '';
  const el = document.head.querySelector<HTMLMetaElement>(selector);
  return el?.getAttribute('content') ?? '';
}

function readCanonical(): string {
  if (typeof document === 'undefined') return '';
  const el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  return el?.getAttribute('href') ?? '';
}

export const initialSeo = {
  title: typeof document !== 'undefined' ? document.title : '',
  description: readMeta('meta[name="description"]'),
  keywords: readMeta('meta[name="keywords"]'),
  canonical: readCanonical(),
  ogType: readMeta('meta[property="og:type"]'),
  ogTitle: readMeta('meta[property="og:title"]'),
  ogDescription: readMeta('meta[property="og:description"]'),
  ogUrl: readMeta('meta[property="og:url"]'),
  twitterTitle: readMeta('meta[name="twitter:title"]'),
  twitterDescription: readMeta('meta[name="twitter:description"]'),
};

export interface SeoMeta {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogType: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  twitterTitle: string;
  twitterDescription: string;
}

function setTitle(title: string) {
  document.title = title;
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applySeoMeta(meta: SeoMeta) {
  setTitle(meta.title);
  setMeta('name', 'description', meta.description);
  setMeta('name', 'keywords', meta.keywords);
  setCanonical(meta.canonical);
  setMeta('property', 'og:type', meta.ogType);
  setMeta('property', 'og:title', meta.ogTitle);
  setMeta('property', 'og:description', meta.ogDescription);
  setMeta('property', 'og:url', meta.ogUrl);
  setMeta('name', 'twitter:title', meta.twitterTitle);
  setMeta('name', 'twitter:description', meta.twitterDescription);
}

export function setRobots(content: string) {
  let el = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', 'robots');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}